// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "meal-1Po0s";
var _3 = "meal__price-1YPcS";
export { _1 as "__esModule", _2 as "meal", _3 as "meal__price" }
export default { "__esModule": _1, "meal": _2, "meal__price": _3 }
